import React from "react";
import { Radio } from "antd";
import { List, Radio as RadioMb } from "antd-mobile";
import { OptionItem, RadioEventProps } from "../../../../../../API/evaluate";
import { RadioChangeEvent } from "antd/es/radio";
import useDeviceType from "../../../../../../Utils/useDeviceType";
import Style from "./index.module.scss";

const RadioMbItem = RadioMb.RadioItem;

interface Props extends RadioEventProps {
    options: OptionItem[];
}
const Index = ({ onChange, value, options, onSave, ...restProps }: Props) => {
    const { isPC } = useDeviceType();
    function Change(e: RadioChangeEvent) {
        onChange?.(e.target.value);
        onSave(e.target.value);
    }
    function mbChange(e: OptionItem) {
        onChange?.(e.id);
        onSave(e.id);
    }
    return (
        <>
            {isPC && (
                <Radio.Group {...restProps} onChange={Change} value={value}>
                    {options.map(item => (
                        <Radio key={item.id} value={item.id}>
                            {item.description}
                        </Radio>
                    ))}
                </Radio.Group>
            )}
            {!isPC && (
                <List>
                    {options.map(item => (
                        <RadioMbItem
                            {...restProps}
                            key={item.id}
                            checked={value === item.id}
                            onChange={() => mbChange(item)}>
                            <span className={Style.text}>
                                {item.description}
                            </span>
                        </RadioMbItem>
                    ))}
                </List>
            )}
        </>
    );
};

export default Index;
